<div class="bb-list bb-block--md">
  <div class="bb-list__item"
       *ngFor="let date of hostRef.transactionsGroupedByDate">
    <bb-transactions-list-item-group [checkImagesList]="hostRef.checkImagesList"
                                     [transactions]="date[1]"
                                     [transactionDate]="date[0]"
                                     [showChangeCategory]="hostRef.showChangeCategory"
                                     [transactionDetailsLoadingStatus]="hostRef.transactionDetailsLoadingStatus"
                                     (detailsOpen)="hostRef.onDetailOpen($event)"></bb-transactions-list-item-group>
  </div>
</div>
